import { hasAccess } from '~/services/permissions/permissions';
import { MessageBox } from 'element-ui-2'

; (function ($, window, document, undefined) {

    "use strict";

    // If a column config's `data` is a function (e.g. a lazy accessor that resolves
    // the row-shape path at render time), fall back to `name` for any API path that
    // expects a stable string identifier: export payloads, saved visible-column
    // lists, form serialization, etc. Functions can't survive JSON/form encoding
    // and don't equal any string in Edit Columns checkbox comparisons.
    function stableColumnKey(column) {
        return typeof column.data === 'function' ? column.name : column.data;
    }

    var pluginName = "dataTableAdvanced",
        plugin,
        table,
        selected_rows = [],
        selected_filters = [],
        filterRules = { inclusion: [], exclusion: [] },
        first_load = false,
        isSelectingAll = false,
        selectAllDrawPending = false,
        exportFiltered = false,
        is_searched = false,
        $info_panel = $('.js-info-panel'),
        $processing = $('.dataTables_processing'),
        pipelineViewIsDirty = false,
        defaults = {
            container_id: 'js-table_container',
            table_id: 'js-dt-table',
            selected: null,
            selectable: {
                style: 'multi+shift',
                selector: 'tr>td:not(.not-selectable)',
                info: false
            },
            height: $(window).height() - ((hasAccess('DemoDashboard') || hasAccess('NewUI')) ? 214 : 210),
            search_placeholder: 'Search',
            active_filter_indicator: false,
            data_url: '',
            filter_form_url: '',
            filters: {},
            resetToFilterValues: false, // If true, will set the search to whatever is defined in "filters" rather than resetting all fields
            reset_button_callback: null, // If this is a function, it will be called after the Reset button is invoked
            forcedFilters: [],
            use_floating_filter_row: false, // If true, will render the floating footer as a row and populate it with the "footerData" object in the AJAX response
            search: '',
            searchDelay: 800,
            reset: 0,
            persist_selections: true,
            fixedColumnsLeft: 0,
            buttonTemplate: false,
            filterTemplate: false,
            listControlsTemplate: false,
            metricsCards: false,
            columns: [],
            temp_included_columns: [],
            buttons: [],
            form_enctype: '',
            order: [[0, 'desc']],
            show_notify_shared_users_button: false,
            context_storage_key: null,
            colReorder: false,
            stateSave: true,
            resetSelectionOnFilter: false,
            exportExtraParams: null,
            initComplete: function (settings, json) {
            },
            onLoad: function (table, plugin) {
            },
            slidePanelOnClose: function () {
            },

            onReset: function (table) {
                table.search('').columns().search('').draw();
            },

            drawCallback: function (table) {
            },
            enable_column_chooser: true,
            paginate: false,
            new_style: false
        };


    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
    };

    $.extend(Plugin.prototype, {
        init: function () {
            plugin = this;
            plugin.appendTable();
            plugin.extendButtons();
            plugin.setSelectionFromStorage();
            table = plugin.initDataTable();
            plugin.registerButtons();
            plugin.registerEvents();
            plugin._setButtonsContainerClass();
            plugin._appendMobileSearch();
            plugin.settings.onLoad(table, plugin, selected_rows);
            plugin.setupDefaultSearch();
            plugin._registerTemplateButtons();
            plugin._adjustOnSidebarToggle();
            plugin.registerSearchEnabled();
            plugin.registerErrorHandler();
            plugin.registerResize();
        },

        appendTable: function () {
            var table_id = plugin.settings.table_id;

            if ($('.dt-advanced', this.element).length === 0) {
                $('<table/>', {
                    id: table_id,
                    class: 'table table-condensed dt-advanced vertical-center' + (plugin.settings.selectable.style == 'single' ? ' no-multi-select' : '')
                }).appendTo(this.element);
            }

            var tableHtml = '<thead></thead><tbody></tbody>';
            if (plugin.settings.use_floating_filter_row) {
                tableHtml += plugin.generateFooterRowHtml(plugin.settings.columns);
            }

            $('#' + table_id).html(tableHtml);
        },

        generateFooterRowHtml: function (columns) {
            var html = '';
            for (var i in columns) {
                if (!columns[i].data) {
                    continue;
                }

                html += '<td name="' + columns[i].name + '"></td>';
            }

            return '<tfoot><tr>' + html + '</tr></tfoot>';
        },

        setupDefaultSearch: function () {
            var filters = plugin.settings.filters;

            if (plugin.settings.reset) {
                plugin._resetAll(table);
            }

            var search = plugin.settings.search;
            if (search) {
                is_searched = true;
                table.search(search.value);
                if (plugin.settings.new_style) {
                    var searchIcon = '<i class="el-input__icon el-icon-search"></i>';
                    $('.filter-tools label').addClass('lead-search').prepend(searchIcon);
                }
            }

            if (!$.isEmptyObject(filters)) {
                $.each(filters, function (field_name, value) {
                    is_searched = true;
                    table.column(field_name + ':name').search(value);
                });
            } else {
                is_searched = true;
            }

            table.draw();
        },

        _resetAll: function (table, callback) {
            table.state.clear();
            table.search('').columns().search('');
            table.rows($('.data-row.selected')).deselect();
            sessionStorage.removeItem(plugin.settings.table_id + '-selected-rows');
            selected_rows = [];

            if (typeof callback === 'function') {
                callback();
            }
        },

        _adjustOnSidebarToggle: function () {
            $('.js-sidebar-toggle').on('click', function () {
                // Timeout is used to wait for the sidebar animation to finish
                setTimeout(function () {
                    // we draw to resize the header on sidebar open or close.
                    // the normal "table.columns.adjust()" function does not work here
                    table.draw(false);
                }, 300);
            });
        },

        onExportClick: function (exportAllRows = true, exportAllColumns = false, applyFilterRules = true) {
            if (plugin.settings.limitExport) {
                const pageInfo = table.page.info();
                const maxRecords = 3000;

                if (pageInfo.recordsTotal >= maxRecords) {
                    const recordText = plugin.settings.warningRecordText ?? 'records';

                    MessageBox.confirm(`Results for ${maxRecords.toLocaleString()} of ${pageInfo.recordsTotal.toLocaleString()} ${recordText} will be exported. To export a larger number of ${recordText}, please reach out to your customer success team to set up recurring reporting`, 'Maximum Export Limit Reached', {
                        confirmButtonText: 'Export',
                        cancelButtonText: 'Cancel',
                        iconClass: 'text-warning fa-solid fa-triangle-exclamation',
                        customClass: 'exportLimitModal',
                    }).then(() => {
                        plugin.triggerExport(exportAllRows, exportAllColumns, applyFilterRules, maxRecords);
                    });

                    return;
                }
            }

            plugin.triggerExport(exportAllRows, exportAllColumns, applyFilterRules);
        },

        triggerExport: function (exportAllRows = true, exportAllColumns = false, applyFilterRules = true, limit = -1) {
            var defaultFilters = [];
            for (var k in plugin.settings.filters) {
                defaultFilters.push({
                    name: k,
                    value: plugin.settings.filters[k]
                });
            }

            var params = table.ajax.params();
            if (params.columns || defaultFilters.length) {
                params.columns = Object.assign(defaultFilters, params.columns);
            }
            params.includeColumns = [];
            params.export = 1;
            params.length = limit;
            params.applyFilterRules = applyFilterRules;

            if (exportAllColumns) {
                plugin.settings.columns.forEach(column => {
                    if (column.data) {
                        params.includeColumns.push({
                            col: stableColumnKey(column),
                            title: column.title
                        })
                    }
                })
            } else {
                var visibleColumns = table.columns().visible();
                var columns = plugin.settings.columns;
                for (var index in visibleColumns) {
                    if (!visibleColumns.hasOwnProperty(index) || !visibleColumns[index] || !columns[index]) {
                        continue;
                    }

                    var transposedIndex = plugin.transposeColumnIndexes(index, 'toOriginal');

                    if (columns[transposedIndex] && columns[transposedIndex].data) {
                        params.includeColumns.push({
                            col: stableColumnKey(columns[transposedIndex]),
                            title: columns[transposedIndex].title
                        });
                    }
                }
            }

            $('form[name=exportform]').remove();
            var $form = $('<form name="exportform" method="POST" action="' + table.ajax.url() + '"></form>');
            $.each(plugin.flattenParams(params), function (i, item) {
                $('<input>').attr({
                    type: 'hidden',
                    name: i,
                    value: item
                }).appendTo($form);
            });

            if (!exportAllRows) {
                $form.append($('<input type="hidden" name="columns[0][name]" value="ids"/>'));
                $form.append($('<input type="hidden" name="columns[0][value]" value="' + JSON.parse(sessionStorage.getItem(plugin.settings.table_id + '-selected-rows')).join('|') + '"/>'));
            }
            $form.append($('<input type="hidden" name="_token" value="' + $('meta[name="_token"]').attr('content') + '"/>'));

            // Allow passing optional params to export requests via hidden form elements
            if (typeof plugin.settings.exportExtraParams === 'function') {
                var extras = plugin.settings.exportExtraParams() || {};
                for (var key in extras) {
                    if (Object.prototype.hasOwnProperty.call(extras, key)) {
                        $('<input>').attr({ type: 'hidden', name: key, value: extras[key] }).appendTo($form);
                    }
                }
            }

            $form.appendTo($('body'));
            document.forms.exportform.submit();
        },

        reloadTable: function () {
            table.draw(false);
            plugin.resizeScroll(true);
        },

        getTable() {
            return table;
        },

        getVisibleColumnNames: function () {
            const columnData = plugin.settings.columns;
            const visibleColumns = table.columns().visible();
            const orderedColIndexes = table.colReorder.order();
            const visibleColumnNames = [];

            orderedColIndexes.forEach((colIndex, i) => {
                if (visibleColumns[i] == true && columnData[colIndex].data) {
                    visibleColumnNames.push(stableColumnKey(columnData[colIndex]));
                }
            })

            return visibleColumnNames;
        },

        setColumnVisibility: function (columns, shouldBeVisible) {
            table.columns(columns).visible(shouldBeVisible);

            if (shouldBeVisible) {
                table.draw();
            }
        },

        getColumnIndexesFromColumnNames: function (columnNames, transpose = null) {
            if (!Array.isArray(columnNames)) {
                columnNames = [columnNames];
            }

            const columnData = plugin.settings.columns;
            let colIndexes = [];

            columnNames.forEach(name => {
                columnData.forEach((column, index) => {
                    if (column.name == name) {
                        colIndexes.push(index);
                    }
                });
            });

            if (transpose) {
                colIndexes = plugin.transposeColumnIndexes(colIndexes, transpose);
            }

            return colIndexes;
        },

        // Convert one or more column indexes to and from current and original indexes.
        transposeColumnIndexes: function (columns, direction) {
            return table.colReorder.transpose(columns, direction);
        },

        getSortOrder: function () {
            return table.order();
        },

        setSortOrder: function (order) {
            table.order(order);
        },

        getColumnOrder: function () {
            return table.colReorder.order();
        },

        setColumnOrder: function (order, originalIndexes) {
            table.colReorder.order(order, originalIndexes);
        },

        resetColumnOrder: function () {
            table.colReorder.reset();
        },

        setFilterRules: function (filterConfiguration, resetSearch = false) {
            if (resetSearch) {
                table.search('').columns().search('');
            }
            is_searched = true;
            filterRules = filterConfiguration;

            table.draw();
        },

        setPipelineViewIsDirty: function (isDirty) {
            pipelineViewIsDirty = isDirty;
        },

        setStartPage: function (page) {
            table.settings()[0]._iDisplayStart = page * table.page.len();
            table.draw(false);
        },

        getFilterRules: function () {
            return filterRules || { inclusion: [], exclusion: [] };
        },

        clearSelections: function () {
            this._deselectAll(table, $('.dataTables_scrollHead table thead th.select-checkbox', plugin.element));
        },

        flattenParams: function (params, prefix, out) {
            out = out || {};
            prefix = prefix || '';
            function prefixKey(key) {
                return prefix ? prefix + '[' + key + ']' : key;
            }
            if (Array.isArray(params)) {
                for (var i = 0; i < params.length; i++) {
                    this.flattenParams(params[i], prefixKey(i), out);
                }
            } else if (typeof params === 'object' && params != null) {
                for (var key in params) {
                    if (params.hasOwnProperty(key)) {
                        this.flattenParams(params[key], prefixKey(key), out);
                    }
                }
            } else {
                out[prefix] = params;
            }
            return out;
        },

        _registerTemplateButtons: function () {
            $('#content').on('click', '.js-lead-action', function () {
                var $this = $(this);
                var action = $this.attr('data-name');
                var rowId = $this.parentsUntil('tr[data-row-id]').parent().attr('data-row-id');
                plugin.setupAction(rowId, action);
            }).on('click', '.js-dt-bulk-actions', function () {
                table.buttons($(this).attr('data-name') + ':name').trigger();
            }).on('click', '.js-server-export', function () {
                plugin.onExportClick();
            });
        },

        _appendMobileSearch: function () {
            var result = '';
            var container = $('#' + plugin.settings.table_id + '_wrapper').find('.plugin-header');

            result += '<div class="col-xs-12 dtwrap-mobile-search">';
            result += '<div class="input-group m-l-15 m-r-15 m-b-5 m-t-5">';
            result += '<input class="form-control js-dt-mobile-search" type="search" data-name="search" placeholder="Search">';
            result += '<span class="input-group-btn">';
            result += '<button class="btn btn-primary js-dt-mobile-submit" type="button">Search</button>';
            result += '</span>';
            result += '</div>';
            result += '</div>';

            container.append(result);

            $('#content').on('click', '.js-dt-mobile-submit', function () {
                table.search($('.js-dt-mobile-search').val()).columns().search().draw();
            });
        },

        _setButtonTooltip: function (title) {
            return {
                'data-toggle': "tooltip",
                'data-trigger': "hover",
                'data-container': "#content",
                'data-placement': "bottom",
                'title': title
            };
        },

        _setButtonsRows: function (dt, self, isSingle) {
            dt.on('select.dt.DT deselect.dt.DT', function () {
                if (isSingle) {
                    self.enable(dt.rows({ selected: true }).count() === 1);
                } else {
                    self.enable(dt.rows({ selected: true }).any());
                }
            });

            self.disable();
        },

        setForcedFilters: function (forcedFilters) {
            if (forcedFilters) {
                plugin.settings.forcedFilters = forcedFilters;
            }
            function appendHiddenInputAndDisable(field) {
                var hiddenSelectInput = $('<input>')
                    .attr('type', 'hidden')
                    .attr('name', field.attr('name'))
                    .val(field.val())
                    .prop('readonly', true);
                field.after(hiddenSelectInput);
                field.prop('disabled', true);
            }

            $.each(plugin.settings.forcedFilters, function (index, filterName) {
                var nameAttr = 'filters[' + filterName + ']';
                var element = $(':input[name^="' + nameAttr + '"]');
                switch (element.prop('type')) {
                    case "select":
                    case "select-one":
                    case "select-multiple":
                    case "checkbox":
                    case "radio":
                        appendHiddenInputAndDisable(element);
                        break;
                    default:
                        element.prop('readonly', true);
                }
            });
        },

        getSelectedRows: function () {
            if (plugin.settings.resetSelectionOnFilter && plugin.settings.selectable.style == "single" && selected_rows.length == 2) {
                // If row was selected prior to initiating a search, this removes it.
                selected_rows[0] = selected_rows.pop();
            }
            return selected_rows;
        },

        getSelectedRowData: function () {
            var selectedRowData = [];
            var currentLeadData;

            for (var i = 0; i < table.data().length; i++) {
                currentLeadData = table.data()[i];

                if ($.inArray(currentLeadData.id, selected_rows) !== -1) {
                    selectedRowData.push(currentLeadData);
                }
            }

            return selectedRowData;
        },

        getRowData: function (id) {
            return table.row($('tr[data-row-id="' + id + '"]')).data();
        },

        getValidationNotices: function (validationFunctions) {
            var notices = [];
            var validationFunctionsCopy;
            var selectedRowData;

            if (validationFunctions.length === 0) {
                return notices;
            }

            validationFunctionsCopy = validationFunctions.slice();
            selectedRowData = plugin.getSelectedRowData();

            for (var i = 0; i < selectedRowData.length; i++) {
                var currentRowData = selectedRowData[i];

                if (validationFunctionsCopy.length === 0) {
                    break;
                }

                for (var j = validationFunctionsCopy.length; j >= 0; j--) {
                    var currentValidationFunction = validationFunctionsCopy[j];

                    if (typeof currentValidationFunction === 'function') {
                        var validationResult = currentValidationFunction(currentRowData);

                        if (validationResult) {
                            notices.push(validationResult);
                            validationFunctionsCopy.splice(j, 1);
                        }
                    }
                }
            }

            return notices;
        },

        getValidationNoticeHtml: function (validationMessage, notices) {
            var noticeHtml = $('<div></div>');
            var noticeMessage = $('<p></p>').text(validationMessage);
            var noticesList = $('<ul></ul>');

            for (var i = 0; i < notices.length; i++) {
                var noticeListItem = $('<li></li>');
                noticeListItem.text(notices[i]);
                noticesList.append(noticeListItem);
            }

            return noticeHtml
                .append(noticeMessage)
                .append(noticesList)
                .prop('outerHTML');
        },

        extendButtons: function () {
            $.fn.dataTable.ext.buttons.create = {
                text: '<i class="fa fa-plus"></i><span class="p-l-5 visible-lg-inline-block"> Create</span>',
                key: 'a',
                titleAttr: 'Create',
                className: 'btn btn-primary m-r-5 dt-create-btn js-create-button',
                name: 'create',
                action: function (e, dt, node, config) {
                    if (config.action_href) {
                        window.location.href = config.action_href;
                        return;
                    }
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url,
                        form_enctype: plugin.settings.form_enctype,
                        onPost: function (response) {
                            dt.row.add(response).draw();
                        }
                    }).data('plugin_slidePanel').form();
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                }
            };

            $.fn.dataTable.ext.buttons.update = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-pencil-square-o"></i>',
                titleAttr: 'Update Selected',
                key: 'u',
                className: 'btn btn-white m-r-5 dt-update-btn js-update-btn',
                name: 'update',
                action: function (e, dt, node, config) {
                    if (config.action_href) {
                        window.location.href = config.action_href + '/' + $('.data-row.selected').attr('data-row-id');
                        return;
                    }
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url + '/' + $('.data-row.selected').attr('data-row-id'),
                        form_enctype: plugin.settings.form_enctype,
                        onPost: function (response) {
                            dt.row($('tr[data-row-id="' + response.id + '"]')).data(response).draw();
                        }
                    }).data('plugin_slidePanel').form();
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.bulk_update = {
                text: '<i class="fa fa-pencil-square-o"></i> (<span class="js-selected-count"></span>)',
                titleAttr: 'Update Multiple Selected',
                key: 'u',
                className: 'btn btn-white m-r-5 dt-update-btn js-update-btn',
                name: 'update',
                action: function (e, dt, node, config) {
                    if (config.action_href) {
                        window.location.href = config.action_href + '/' + $('.data-row.selected').attr('data-row-id');
                        return;
                    }
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url + '/' + $('.data-row.selected').attr('data-row-id'),
                        form_enctype: plugin.settings.form_enctype,
                        additional_data: '&' + $.param({
                            ids: selected_rows
                        }),
                        onPost: function (responses) {
                            if (responses[0].status == 1) {
                                buildFlashMessage(responses[0].message, 'success');
                                responses.forEach(response => {
                                    dt.row($('tr[data-row-id="' + response.id + '"]')).data(response).draw();
                                })
                            } else {
                                buildFlashMessage(responses[0].message, 'warning');
                            }
                        }
                    }).data('plugin_slidePanel').form();
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this);
                }
            };

            $.fn.dataTable.ext.buttons.row_copy = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-copy"></i>',
                titleAttr: 'Copy Selected',
                className: 'btn btn-white m-r-5 dt-update-btn js-update-btn',
                name: 'row_copy',
                action: function (e, dt, node, config) {
                    if (config.action_href) {
                        window.location.href = config.action_href + '/' + $('.data-row.selected').attr('data-row-id');
                        return;
                    }
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url + '/' + $('.data-row.selected').attr('data-row-id'),
                        form_enctype: plugin.settings.form_enctype,
                        onPost: function (response) {
                            dt.row.add(response).draw();
                        }
                    }).data('plugin_slidePanel').form();
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.bulk_delete = {
                text: '<i class="fa fa-trash-o"></i> (<span class="js-selected-count"></span>)',
                titleAttr: 'Delete Selected',
                key: 'd',
                className: 'btn btn-white text-danger m-r-5 dt-delete-btn js-delete-btn',
                name: 'bulk_delete',
                action: function (e, dt, node, config) {
                    var row_count = selected_rows.length;
                    var modalText = 'Are you absolutely sure you want to permanently delete these ' + row_count + ' records?';

                    if (config.additional_confirmation_text) {
                        modalText += "<br /><br />";
                        modalText += config.additional_confirmation_text;
                    }

                    confirmModal(modalText).then(function () {
                        $processing.show();

                        $.ajax({
                            type: "POST",
                            url: config.action_url,
                            data: {
                                ids: selected_rows
                            },
                            success: function (data) {
                                const currentPage = dt.page();
                                plugin.clearSelections();

                                if (data.failedIds) {
                                    data.failedIds.forEach(id => {
                                        selected_rows.push('' + id + '');
                                    });
                                }

                                dt.page(currentPage).draw('page');

                                if (data.status == 1) {
                                    buildFlashMessage(data.msg, 'success');
                                } else {
                                    buildFlashMessage(data.msg, 'warning');
                                }
                            },
                            error: function (error) {
                                if (error && (error.status === 502 || error.status === 504)) {
                                    const currentPage = dt.page();
                                    plugin.clearSelections();
                                    dt.page(currentPage).draw('page');
                                    buildFlashMessage('This bulk delete action has timed out. Some of the leads may not have been deleted.', 'danger');
                                } else {
                                    buildFlashMessage('An error occurred, selected rows could not be deleted.', 'danger');
                                }
                            },
                            complete: function () {
                                $processing.hide();
                            }
                        });
                    });
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this);
                }
            };
            // use post_delete instead of this to avoid csrf vulnerabilities
            $.fn.dataTable.ext.buttons.delete = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-trash-o"></i>',
                titleAttr: 'Delete Selected',
                confirmationPrompt: 'Are you absolutely sure you want to delete this permanently?',
                key: 'd',
                className: 'btn btn-white text-danger m-r-5 dt-delete-btn js-delete-btn',
                name: 'delete',
                action: function (e, dt, node, config) {
                    var rowId = selected_rows[0];
                    confirmModal(config.confirmationPrompt).then(function () {
                        $processing.show();

                        var xhr = $.get(config.action_url + '/' + rowId, function (response) {
                            dt.row($('tr[data-row-id="' + rowId + '"]')).deselect()
                            dt.row($('tr[data-row-id="' + rowId + '"]')).remove().draw();
                            if (response.msg) {
                                buildFlashMessage(response.msg, (response.status == 1) ? 'success' : 'error');
                            }
                        });

                        xhr.fail(function (response) {
                            plugin.handleButtonResponse(response, false);
                        });
                    });
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.post_delete = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-trash-o"></i>',
                titleAttr: 'Delete Selected',
                confirmationPrompt: `Are you absolutely sure you want to delete this permanently?`,
                key: 'd',
                className: 'btn btn-white text-danger m-r-5 dt-delete-btn js-delete-btn',
                name: 'delete',
                action: function (e, dt, node, config) {
                    var rowId = selected_rows[0];
                    confirmModal(config.confirmationPrompt).then(function () {
                        $processing.show();

                        var xhr = $.post(config.action_url, {
                            'id': rowId
                        }, function (response) {
                            dt.row($('tr[data-row-id="' + rowId + '"]')).deselect()
                            dt.row($('tr[data-row-id="' + rowId + '"]')).remove().draw();
                            if (response.msg) {
                                buildFlashMessage(response.msg, (response.status == 1) ? 'success' : 'error');
                            }
                        });

                        xhr.fail(function (response) {
                            buildFlashMessage(response.responseJSON.msg, 'warning');
                            plugin.handleButtonResponse(response, false);
                        });
                    });
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.update_editable = {
                extend: 'selectedSingle',
                text: 'Make group editable',
                titleAttr: 'Update editability',
                confirmationPrompt: 'Are you absolutely sure you want to make the selected group editable?',
                key: 'd',
                className: 'btn btn-white m-r-5 dt-update-btn js-update-btn',
                name: 'update',
                action: function (e, dt, node, config) {
                    var rowId = selected_rows[0];
                    confirmModal(config.confirmationPrompt).then(function () {
                        $processing.show();
                        var xhr = $.post(config.action_url, {
                            'id': rowId
                        }, function (response) {
                            dt.row($('tr[data-row-id="' + response.id + '"]')).data(response).draw();
                            if (response.msg) {
                                buildFlashMessage(response.msg, (response.status == 1) ? 'success' : 'error');
                            }
                        });

                        xhr.fail(function (response) {
                            plugin.handleButtonResponse(response, false);
                        });
                    });
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.ajax_action = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-bars"></i>',
                titleAttr: 'Action',
                className: 'btn btn-white m-r-5 dt-action-btn',
                confirmationPrompt: 'Are you absolutely sure?',
                name: 'ajax_action',
                action: function (e, dt, node, config) {
                    var rowId = selected_rows[0];
                    confirmModal(config.confirmationPrompt).then(function () {
                        $processing.show();

                        var xhr = $.post(config.action_url + '/' + rowId, 'id=' + rowId + '&' + config.action_data, function (response) {
                            dt.row($('tr[data-row-id="' + rowId + '"]')).deselect().remove().draw();
                        });

                        xhr.fail(function (response) {
                            plugin.handleButtonResponse(response, false);
                        });
                    });
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.action = {
                text: '<i class="fa fa-bars"></i>',
                titleAttr: 'Actions',
                className: 'btn btn-white m-r-5 dt-action-btn',
                action: function (e, dt, node, config) {
                    config.defaultAction(e, dt, node, config);
                },
                defaultAction: function (e, dt, node, config) {
                    var content_url = typeof config.action_url === 'function' ? config.action_url(table) : config.action_url;

                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: content_url,
                        form_enctype: plugin.settings.form_enctype,
                        additional_data: '&' + $.param({
                            id: selected_rows
                        }),
                        show_notify_shared_users_button: plugin.settings.show_notify_shared_users_button,
                        onPost: function (data) {
                            const currentPage = dt.page();
                            if (typeof (config.successHandler) === 'function') {
                                config.successHandler(data);
                            } else {
                                dt.ajax.reload();
                            }
                            dt.page(currentPage).draw('page');
                        },
                        onPostError: function (data) {
                            if (typeof (config.errorHandler) === 'function') {
                                config.errorHandler(data);
                            }
                        },
                        onLoad: config.onPanelLoad ? config.onPanelLoad : function (plugin) { }
                    }).data('plugin_slidePanel').form();
                }
            };

            $.fn.dataTable.ext.buttons.validate_action = {
                extend: 'action',
                validationMessage: 'One or more of your selected contacts will be excluded from your communication for the following reasons:',
                validationFunctions: [],
                validateAction: function (plugin, e, dt, node, config) {
                    var notices = plugin.getValidationNotices(config.validationFunctions);
                    if (notices.length > 0) {
                        var modalHtml = plugin.getValidationNoticeHtml(config.validationMessage, notices);

                        confirmModal(
                            modalHtml
                        ).then(function () {
                            config.defaultAction(e, dt, node, config);
                        });
                    } else {
                        config.defaultAction(e, dt, node, config);
                    }
                },
                action: function (e, dt, node, config) {
                    config.validateAction(plugin, e, dt, node, config);
                }
            };

            $.fn.dataTable.ext.buttons.vue_action = {
                extend: 'action',
                action: function (e, dt, node, config) {
                    $(document).trigger('dataTables:vueAction', {
                        name: config.name,
                        selected: plugin.getSelectedRows(),
                        data: plugin.getSelectedRowData(),
                        config: config
                    });
                }
            };

            $.fn.dataTable.ext.buttons.table_action = {
                text: '<i class="fa fa-bars"></i>',
                titleAttr: 'Actions',
                className: 'btn btn-white dt-action-btn',
                action: function (e, dt, node, config) {
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url,
                        form_enctype: plugin.settings.form_enctype,
                        onPost: function () {
                            dt.ajax.reload();
                        },
                        onLoad: config.onPanelLoad ? config.onPanelLoad : function () { }
                    }).data('plugin_slidePanel').form();
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                }
            };

            $.fn.dataTable.ext.buttons.quick_action = {
                text: '<i class="fa fa-bars"></i>',
                titleAttr: 'Actions',
                className: 'btn btn-white text-info dt-info-btn',
                action: function (e, dt, node, config) {
                    if (typeof config.preAction === 'function') {
                        if (config.preAction(plugin, dt, config) === false) {
                            return;
                        }
                    }

                    var rows = {
                        id: selected_rows
                    };
                    if (config.link_url) {
                        if (config.link_url.slice(-1) == '/') {
                            window.location.href = config.link_url + $('.data-row.selected').attr('data-row-id');
                        } else {
                            window.location.href = config.link_url;
                        }
                        return;
                    }
                    const currentPage = dt.page();
                    var xhr = $.post(config.action_url, config.action_data + '&' + $.param(rows), function (response) {
                        plugin.handleButtonResponse(response);
                        dt.ajax.reload();
                    });
                    xhr.fail(function (response) {
                        plugin.handleButtonResponse(response, false);
                    });
                    dt.page(currentPage).draw('page');
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                }
            };

            $.fn.dataTable.ext.buttons.info = {
                extend: 'selectedSingle',
                text: '<i class="fa fa-info-circle"></i>',
                titleAttr: 'View Info',
                className: 'btn btn-white text-info m-r-5 dt-info-btn js-info-btn',
                action: function (e, dt, node, config) {
                    var redirect = config.link_url;
                    var selected_row = $('.data-row.selected').attr('data-row-id');
                    if (config.link_url) {
                        if (redirect.slice(-1) == '/') {
                            if (config.id_field) {
                                var data = dt.row({ selected: true }).data();
                                redirect += data[config.id_field];
                            } else {
                                redirect += selected_row;
                            }
                        }
                        window.location.href = redirect;
                        return;
                    }
                    $info_panel.slidePanel({
                        loading_icon_selector: '.dataTables_processing',
                        content_url: config.action_url + '/' + $('.data-row.selected').attr('data-row-id'),
                        form_enctype: plugin.settings.form_enctype,
                    }).data('plugin_slidePanel').info();
                },
                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    plugin._setButtonsRows(dt, this, true);
                }
            };

            $.fn.dataTable.ext.buttons.server_export = {
                text: '<i class="fa fa-download"></i>',
                titleAttr: 'Export CSV',
                className: 'btn btn-white js-server-export'
            };

            $.fn.dataTable.ext.buttons.replace = {
                text: '<i class="fa fa-retweet"></i><span class="p-l-5 visible-lg-inline-block"> Snippet Find/Replace</span>',
                key: 'r',
                titleAttr: "Find and Replace snippet system names within this organization's content",
                className: 'btn btn-primary m-r-5 dt-replace-btn js-replace-button',
                name: 'replace',
                action: function (e, dt, node, config) {
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        form_enctype: plugin.settings.form_enctype
                    });
                },

                init: function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                }
            };
        },

        setSelectionFromStorage: function () {
            if (!plugin.settings.persist_selections) {
                return;
            }
            if (this.settings.selected !== null && Array.isArray(this.settings.selected)) {
                selected_rows = this.settings.selected;
            } else {
                var rows = sessionStorage.getItem(plugin.settings.table_id + '-selected-rows');
                if (rows) {
                    var json_rows = JSON.parse(rows);
                    if (Array.isArray(json_rows)) {
                        selected_rows = json_rows;
                    }
                }
            }
        },

        renderTemplate: function (data, element) {
            var theTemplateScript = $(element).html();
            var theTemplate = Handlebars.compile(theTemplateScript);

            return theTemplate(data);
        },

        isset: function (data, callback) {
            return data ? callback() : '<span clfass="text-grey">--</span>';
        },

        _shouldShowActiveFilterDot: function () {
            var $el = $('.js-dt-red-dot');
            $el.removeClass('in');

            if (plugin.settings.active_filter_indicator && selected_filters && selected_filters.length) {
                if (plugin.settings.resetToFilterValues === false || !plugin._filtersAreEqual(selected_filters, plugin.settings.filters)) {
                    $el.addClass('in');
                }
            }
        },

        _filtersAreEqual: function (selectedFilters, pluginSettingsFilters) {
            for (var i in selectedFilters) {
                if (typeof pluginSettingsFilters[selectedFilters[i].name] === 'undefined') {
                    return false;
                }

                if (pluginSettingsFilters[selectedFilters[i].name] != selectedFilters[i].value) {
                    return false;
                }
            }

            return true;
        },

        initDataTable: function () {
            var table_id = plugin.settings.table_id;
            var data_url = plugin.settings.data_url;
            var columns = plugin.settings.columns;
            var buttons = plugin.settings.buttons;
            var order = plugin.settings.order;
            var initComplete = plugin.settings.initComplete;
            var tempIncludedColumns = $.map(plugin.settings.temp_included_columns, function (column_name) {
                for (var i = 0; i < plugin.settings.columns.length; i++) {
                    if (plugin.settings.columns[i].name === column_name) {
                        return {
                            column_index: i,
                            column_name: column_name,
                            suppress_save: true
                        }
                    }
                }

                return null;
            });

            var paginate = plugin.settings.paginate || false;

            plugin._includeTempColumns(plugin.settings.columns, tempIncludedColumns);

            let pagingOptions = {
                scroller: true
            };

            // limit number of results on mobile so it fits on one line
            if (window.screen.width < 768) {
                $.fn.DataTable.ext.pager.numbers_length = 5;
            }

            if (paginate) {
                let contextStart = 0;

                pagingOptions = {
                    pageLength: 25,
                    pagingType: "simple_numbers",
                    displayStart: contextStart,
                }
            }


            var footerHTML = "";

            if (plugin.settings.new_style && paginate) {
                // place the pagination ("p") first-in-the-DOM on mobile, but last-in-the-DOM on desktop
                footerHTML = "<'row dtwrap-footer'" +
                    "<'col-sm-6 mobile'p><'co-sm-3 mobile'>" +
                    "<'dtwrap-footer-info col-sm-3 pt-5'i>" +
                    "<'col-sm-6 desktop'p><'co-sm-3 desktop'>" +
                    ">";
            }
            else {
                footerHTML = "<'row dtwrap-footer'<'dtwrap-footer-info col-sm-3 pt-5'i>" +
                    (paginate ? "<'col-sm-6'p><'co-sm-3'>" : "S") +
                    ">";
            }

            var dom = "<'row dtwrap-header'r<'col-xs-6 action-tools'B><'col-xs-6 filter-tools'f>>" +
                "<'row dtwrap-body'<'col-sm-12't>>" +
                footerHTML;

            // if list controls are specified, we need to rearrange the DOM to make the .list-tools element fit
            if (plugin.settings.listControlsTemplate) {
                if (plugin.settings.metricsCards) {
                    dom = "<'dtwrap-header'r<'action-tools'B><'filter-tools'f><'list-tools'>>" +
                        "<'metrics-cards'>" +
                        "<'row dtwrap-header-info'<'col-sm-12'<'dataTables_info'<'js-selected-count'>>>>" +
                        "<'row dtwrap-body'<'col-sm-12't>>" +
                        footerHTML;
                } else {
                    dom = "<'dtwrap-header'r<'action-tools'B><'filter-tools'f><'list-tools'>>" +
                        "<'row dtwrap-header-info'<'col-sm-12'<'dataTables_info'<'js-selected-count'>>>>" +
                        "<'row dtwrap-body'<'col-sm-12't>>" +
                        footerHTML;
                }
            }

            var _data_table = $('#' + table_id).DataTable({

                dom: dom,

                buttons: [...[], ...this._defaults.buttons, ...buttons],
                colReorder: plugin.settings.colReorder, //if this is enabled, evaluate the tempIncludedColumns object to ensure that caching the column index won't break things.
                columns: columns,
                autoWidth: true,
                //responsive:true,
                order: order,
                stateSave: plugin.settings.stateSave,
                stateDuration: -1,
                search: {
                    smart: false
                },
                searchDelay: plugin.settings.searchDelay,
                serverSide: true,
                processing: !plugin.settings.new_style,
                deferRender: true,
                scrollX: true,
                scrollY: plugin.settings.height,
                ...pagingOptions,
                fixedColumns: {
                    leftColumns: plugin.settings.fixedColumnsLeft
                },

                stateSaveParams: function (settings, data) {
                    $.each(tempIncludedColumns, function (index, tempColumn) {
                        if (tempColumn.suppress_save) {
                            data.columns[tempColumn.column_index].visible = false;
                        }
                    });
                },

                stateLoadParams: function (settings, data) {
                    // Dont save scroll position, It causes weird bugs
                    delete data.iScroller;
                    delete data.iScrollerTopRow;

                    plugin._includeTempColumns(data.columns, tempIncludedColumns);
                },
                language: {
                    processing: '',
                    search: '',
                    info: plugin.settings.info,
                    infoEmpty: plugin.settings.info_empty,
                    emptyTable: plugin.settings.empty_table,
                    searchPlaceholder: plugin.settings.search_placeholder,
                    lengthMenu: '_MENU_',
                    paginate: {
                        ellipsis: 'test',
                        previous: '&lt',
                        next: '&gt'
                    }
                },
                select: plugin.settings.selectable,
                preDrawCallback: function () {
                    $('th.select-checkbox').eq(0).html('<span class="el-checkbox__inner"></span>');
                    return is_searched;
                },
                createdRow: function (row, data, dataIndex) {
                    var $row = $(row);
                    var dtRow = this.api().row(row);

                    $row.addClass('data-row').attr('data-row-id', data.id);

                    if (selected_rows && selected_rows.indexOf(data.id) !== -1) {
                        dtRow.select();
                        $row.addClass('selected');
                    }

                    // Need this to find index of row in total results.
                    $row.attr('data-row-display-index', dataIndex + dtRow.settings()[0]._iDisplayStart);
                },
                footerCallback: function () {
                    this.api().rows('.selected').select();
                    if (exportFiltered === true) {
                        table.buttons('export_csv:name').trigger();
                        exportFiltered = false;
                    }
                },
                drawCallback: function (settings) {
                    initializeTooltips($('[data-toggle="tooltip"]'));
                    initializePopovers($('[data-toggle="popover"]'));
                    initializeFeatherlight($('a[data-featherlight="image"]'));
                    plugin._shouldShowActiveFilterDot();
                    plugin.settings.drawCallback(table);
                    plugin._selectAllCallback();
                    plugin._selectAllDrawCallback();
                    plugin.updateSelectionText();
                    plugin.resizeScroll(false);

                    function initializeTooltips(elements) {
                        if (elements.length) {
                            elements.tooltip();
                        }
                    };
                    function initializePopovers(elements) {
                        if (elements.length) {
                            elements.each(function (index, element) {
                                var popoverType = $(element).data('popover-type');
                                if (popoverType === 'ci-popover') {
                                    var popoverTemplate = `
                                        <div class="ci-popover" role="tooltip">
                                            <div class="arrow"></div>
                                            <h3 class="popover-title"></h3>
                                            <div class="popover-content"></div>
                                        </div>`;
                                    $(this).popover({
                                        trigger: 'focus hover',
                                        template: popoverTemplate
                                    }).css('text-align', 'left');
                                } else {
                                    $(this).popover({ trigger: 'focus hover' }).css('text-align', 'left');
                                }
                            });
                        }
                    };
                    function initializeFeatherlight(elements) {
                        if (elements.length) {
                            elements.featherlight();
                        }
                    };
                },
                initComplete: initComplete,
                ajax: {
                    url: data_url,
                    method: plugin.settings.use_filter_rule_builder || plugin.settings.use_post ? 'POST' : 'GET',
                    data: function (data) {
                        if (exportFiltered === true) {
                            data.length = 1000;
                        }
                        data.order[0].column_name = data.columns[data.order[0].column].name;
                        if ($('.dataTable.table thead th.select-checkbox', plugin.element).hasClass('selected')) {
                            data.ids = 1;
                        }

                        if (plugin.settings.use_filter_rule_builder) {
                            data.columns = [];
                            data.filterRules = JSON.stringify(filterRules);
                        }
                        else {
                            selected_filters = [];
                            $.each(data.columns, function (key, col) {
                                if (col.searchable && col.search.value && col.search.value != 'null') {
                                    var column_value = col.search.value;
                                    selected_filters.push({
                                        name: col.name,
                                        value: column_value
                                    });
                                }
                            });
                            data.columns = selected_filters;
                        }

                        return data;
                    },
                    complete: function (response) {
                        if (!plugin.settings.use_floating_filter_row || !response.responseJSON || !response.responseJSON.footerData) {
                            return;
                        }

                        var footerData = response.responseJSON.footerData;
                        var $tableContainer = $('#' + plugin.settings.table_id).parentsUntil('.dtwrap-body').find('.dataTables_scrollFoot tfoot');

                        $tableContainer.find('td:eq(0)').text('Total');

                        for (var columnName in footerData) {
                            var $cell = $tableContainer.find('td[name="' + columnName + '"]');
                            if ($cell.length) {
                                $cell.text(footerData[columnName]);
                            }
                        }
                    }
                },

                columnDefs: [
                    {
                        orderable: false,
                        title: '',
                        width: '30px',
                        targets: this.getColumnIndexesWithClass(columns, 'select-checkbox'),
                        data: null,
                        render: function () {
                            return '<span class="el-checkbox__inner"></span>';
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'has-indicator'),
                        render: function (data, type, full) {
                            return (data && data != '0') ? '<i class="fa fa-check text-success"></i>' : '';
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'has-negative-indicator'),
                        render: function (data, type, full) {
                            return (data && data != '0') ? '<i class="fa fa-times text-danger"></i>' : '';
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'has-positive-and-negative-indicator'),
                        render: function (data, type, full) {
                            return (data && data != '0') ? '<i class="fa fa-check text-success"></i>' : '<i class="fa fa-times text-danger"></i>';
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'phone-col'),
                        render: function (data, type, full, meta) {
                            var columnDataKey = table.settings().init().columns[meta.col].name;
                            var e164ColumnDataKey = columnDataKey + '_e164';
                            var renderedData = '';
                            if (data) {
                                if (e164ColumnDataKey in full && full[e164ColumnDataKey] === null) {
                                    renderedData = data + ' <i title="Invalid Phone Number" class="fa fa-exclamation text-danger m-l-5"></i>';
                                } else {
                                    renderedData = '<a href="tel:' + data + '">' + data + '</a>';
                                }
                            }
                            return xss(renderedData);
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'external-link-col'),
                        render: function (data, type, full) {
                            return data ? xss('<a target="_blank" rel="noopener" href="' + data + '">' + data + '</a>') : '';
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'count-col'),
                        type: 'num'
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'full-name-col'),
                        render: function (data, type, full) {
                            var full_name = '';
                            if (full.f_name) {
                                full_name += full.f_name;
                            }
                            if (full.l_name) {
                                full_name += ' ' + full.l_name;
                            }
                            return xss(full_name);
                        }
                    },
                    {
                        targets: this.getColumnIndexesWithClass(columns, 'money-col'),
                        render: function (data, type, full) {
                            return (data && data != '0') ? '$' + xss(Number(data).toLocaleString()) : '';
                        }
                    },

                    {
                        targets: this.getColumnIndexesWithClass(columns, 'filter-col'),
                        orderable: false,
                        title: '',
                        data: null,
                        visible: false,
                        render: function () {
                            return '';
                        }
                    },
                    // Keep this one at bottom to default to rendering text for XSS protection.
                    {
                        targets: '_all',
                        defaultContent: '',
                        render: $.fn.dataTable.render.text()
                    }
                ]
            });

            _data_table.on('column-visibility.dt', function (e, settings, column) {
                $.each(tempIncludedColumns, function (_, temp_column) {
                    if (temp_column.column_index === column) {
                        temp_column.suppress_save = false;
                    }
                })
            })

            // whenever the table is redrawn, ensure the js-multi-select-show/js-multi-select-hide buttons are shown/hidden again properly.
            // otherwise, when the table is redrawn (such as when changing pages), the visibility of those buttons may not reflect the state of the table.
            _data_table.on('draw.dt', function () {
                plugin._shouldShowButtons();
            });

            if (plugin.settings.new_style) {
                $(_data_table.table().container()).addClass('new-style');
            }

            return _data_table;
        },

        handleButtonResponse: function (response, status) {
            var icon = '<div class="js-success-icon pull-left text-success m-t-4 m-l-5 m-b-0"><i class="fa fa-2x fa-check-circle" style="vertical-align: middle;"></i> Success!</div>';
            if (!status) {
                icon = '<div class="js-success-icon pull-left text-danger m-t-4 m-l-5 m-b-0"><i class="fa fa-2x fa-times" style="vertical-align: middle;"></i> Fail!</div>';
            }
            $processing.hide().after(icon);
            $('.js-success-icon').fadeOut(3000, function () { $(this).remove(); });
        },

        getColumnIndexesWithClass: function (columns, className) {
            var indexes = [];
            $.each(columns, function (index, columnInfo) {
                if (columnInfo && columnInfo.className && columnInfo.className.split(' ').indexOf(className) !== -1) {
                    indexes.push(index);
                }
            });
            return indexes;
        },

        _setButtonsContainerClass: function () {
            $(table.buttons().containers()).removeClass('btn-group');
        },

        registerSearchEnabled: function () {

            var dtwrap = plugin;
            var container = $('#' + dtwrap.settings.table_id + '_wrapper').find('.dataTables_filter');
            var searchNode = container.find('input[type=search]');

            if (!plugin.settings['disable_search']) {
                searchNode.show();
            }
            else {
                searchNode.hide();
            }
        },

        registerErrorHandler: function () {
            $.fn.dataTable.ext.errMode = function (e, settings, techNote, message) {
                buildFlashMessage('An error occurred performing this operation.', 'danger');
                return false;
            };
        },

        registerResize: function () {
            // Namespaced + off-before-on so re-init can't accumulate duplicate
            // window-resize handlers (each leftover one would refetch). Same guard
            // as the el-select:change.dtwrap handler below.
            $(window).off('resize.dtwrap');

            // Cheap: adjust the scroll-body height live so the table tracks the drag.
            // resizeScroll(false) skips scroller.measure(), so it never refetches.
            $(window).on('resize.dtwrap', function () {
                plugin.resizeScroll(false);
            });

            // Expensive: measure + server refetch — only once the user pauses.
            $(window).on('resize.dtwrap', $.debounce(500, function () {
                plugin.resizeScroll(true);
            }));
        },

        resizeScroll: function (measure = false) {
            const scroll = $('.dataTables_scrollBody', plugin.element);
            let footer = $('.dtwrap-footer', plugin.element);
            let padding = 0;
            if ($('.dataTables_paginate', footer).length) {
                padding = 24;
            }
            const windowDiff = scroll.offset().top + footer.outerHeight() + padding;
            let height;
            scroll.css('height', function () {
                const height = window.innerHeight - windowDiff;
                return height + 'px';
            });
            // recalculate pager counts
            if (measure) {
                const table = $('#' + plugin.settings.table_id).DataTable();
                table.scroller.measure();
            }
        },

        registerButtons: function () {
            var dtwrap = plugin;

            function getButtons(new_style = false, enable_column_chooser = true) {
                const column_onload = function () {
                    $('a:empty').parent('.buttons-columnVisibility').hide();
                };

                const filter_init = function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip('Filter'));

                    if (!dtwrap.settings.use_filter_rule_builder && !dtwrap.settings.filter_form_url) {
                        $(node).hide();
                    }
                };

                const filter_action = function (e, dt, node, config) {
                    $info_panel.slidePanel({
                        panel_class: 'bg-silver',
                        loading_icon_selector: '.dataTables_processing',
                        content_url: dtwrap.settings.filter_form_url,
                        form_enctype: plugin.settings.form_enctype,
                        onLoad: function () {
                            var filters = table.columns().search();
                            var init_columns = table.settings().init().columns;

                            $.each(filters, function (index, filter) {
                                if (filter) {
                                    var sortedIndex = plugin.transposeColumnIndexes(index, 'toOriginal');
                                    var field_name = init_columns[sortedIndex].name;
                                    var field = $('input[name^="filters[' + field_name + ']"]');
                                    var elSelectField = $(`*[data-input-name="filters[${field_name}]"]`);
                                    var elSelectFieldMulti = $(`*[data-input-name="filters[${field_name}][]"]`);

                                    if (elSelectField.length) {
                                        elSelectField.data('initial-value', filter);
                                    }

                                    if (elSelectFieldMulti.length) {
                                        var elSelectMultiArr = filter.split('|');
                                        elSelectFieldMulti.data('initial-value', elSelectMultiArr);
                                    }

                                    switch (field.prop('type')) {
                                        case "radio":
                                        case "checkbox":
                                            if (field.val() == filter) {
                                                field.attr('checked', 'checked');
                                            }
                                            break;
                                        default:
                                            field.val(filter);
                                            break;
                                    }

                                    field = $('select[name^="filters[' + field_name + ']"]');
                                    switch (field.prop('type')) {
                                        case "select":
                                        case "select-one":
                                        case "select-multiple":
                                            var selected = filter.split('|');

                                            $("option", field).each(function () {
                                                var $this = $(this);

                                                selected.forEach(function (option) {
                                                    if ($this.val() == option) {
                                                        $this.attr('selected', 'selected');
                                                    }
                                                });
                                            });
                                            break;
                                    }
                                }
                            });

                            function getFirstMatch(name) {
                                return name.match(/[^[\]]+(?=])/g)[0];
                            }

                            $('.selectpicker').selectpicker('render');
                            $('.js-selectpicker').trigger('change');
                            // Coalesce same-tick draws into one request (e.g. select2 allowClear
                            // fires 'change' twice on remove → would otherwise be 2 parallel XHRs).
                            var requestFilterDraw = $.debounce(0, function () {
                                table.draw();
                            });
                            $('.js-info-panel-content :input').on('keyup change', function () {
                                var value = $(this).val();
                                var inputName = $(this).attr('name');

                                if (inputName) {
                                    var field_name = getFirstMatch($(this).attr('name'));
                                    if ($.isArray(value)) {
                                        value = $(this).val().join('|');
                                    } else {
                                        if ($(this).attr('type') == 'checkbox') {
                                            value = ($(this).is(':checked')) ? 1 : null;
                                        }
                                    }
                                    table.state.save();
                                    table.column(field_name + ':name').search(value);
                                    requestFilterDraw();
                                }

                            });

                            $(document).off('el-select:change.dtwrap').on('el-select:change.dtwrap', function (event, name, value) {
                                var field_name = getFirstMatch(name);
                                table.state.save();
                                table.column(field_name + ':name').search(value);
                                requestFilterDraw();
                            });

                            plugin.setForcedFilters();
                            $('.selectpicker').selectpicker('refresh');
                        },
                        onClose: typeof plugin.settings.slidePanelOnClose == 'function' ? plugin.settings.slidePanelOnClose : function () { }
                    }).data('plugin_slidePanel').info();
                };

                const reset_init = function (dt, node, config) {
                    $(node).attr(plugin._setButtonTooltip('Reset'));
                }

                const reset_action = function (e, dt, node, config) {
                    if (plugin.settings.resetToFilterValues) {
                        table.state.clear();
                        plugin.setupDefaultSearch();
                        // resetting the paging causes trouble when the user isn't at the top of the table.
                        table.draw(false);
                    } else {
                        plugin._resetAll(table, function () {
                            plugin._setSelectedCallback(table);

                            // resetting the paging causes trouble when the user isn't at the top of the table.
                            table.draw(false);
                        });
                    }

                    if (typeof plugin.settings.reset_button_callback === 'function') {
                        plugin.settings.reset_button_callback(table);
                    }
                }

                const old_columns_button = {
                    extend: 'colvis',
                    columns: ':not(.noVis)',
                    collectionLayout: 'fixed column-dropdown-scroll js-col_vis',
                    key: 'v',
                    text: '<i class="fa fa-columns"></i>',
                    className: 'btn btn-white m-r-5',
                    titleAttr: 'Column Visibility',
                    name: 'col_vis',
                    onLoad: column_onload
                };

                const new_columns_button = {
                    columns: ':not(.noVis)',
                    collectionLayout: 'fixed column-dropdown-scroll js-col_vis',
                    key: 'v',
                    text: '<i class="fa fa-columns"></i> Edit Columns',
                    className: 'btn btn-white m-r-5',
                    titleAttr: 'Edit Columns',
                    attr: {
                        id: "js-action-table-columns"
                    },
                    name: 'col_vis',
                    onLoad: column_onload,
                    action: function (e, dt, node, config) {
                        window.gl.LeadListEditColumnsSlidePanel.$store.commit('leadList/openEditColumnsSlidePanel');
                    },
                    init: function (dt, node, config) {
                        $(node).attr(plugin._setButtonTooltip(config.titleAttr));
                    }
                };

                const old_filter_button = {
                    text: '<i class="fa fa-filter"></i><span class="red-dot js-dt-red-dot fade"></span>',
                    titleAttr: 'Advanced Search',
                    className: 'btn btn-primary m-r-5 relative',
                    name: 'advanced_search',
                    key: 'f',
                    init: filter_init,
                    action: filter_action
                };

                const new_filter_button = {
                    text: '<i class="fa fa-filter"></i><span class="red-dot js-dt-red-dot fade"></span> Filter',
                    titleAttr: 'Advanced Search',
                    className: 'btn btn-white m-r-5 relative desktop',
                    attr: {
                        id: "js-action-table-filter"
                    },
                    name: 'advanced_search',
                    key: 'f',
                    action: function (e, dt, node, config) {
                        window.gl.LeadListEditColumnsSlidePanel.$store.commit('leadFilterRuleBuilder/setEditPanelBodyComponent', 'collapsible-rule-list');
                        window.gl.LeadListEditColumnsSlidePanel.$store.commit('leadFilterRuleBuilder/setEditPanelVisible', true);
                    },
                    init: filter_init
                };


                const old_reset_button = {
                    text: '<i class="fa fa-refresh"></i> Reset',
                    titleAttr: 'Reset Table View',
                    className: 'btn btn-warning',
                    attr: {
                        id: 'js-action-table-reset'
                    },
                    name: 'refresh',
                    key: 'r',
                    action: reset_action,
                    init: reset_init
                };

                const new_reset_button = {
                    text: '<i class="fa fa-refresh"></i> Reset',
                    titleAttr: 'Reset Table View',
                    className: 'btn btn-white',
                    attr: {
                        id: "js-action-table-reset"
                    },
                    name: 'refresh',
                    key: 'r',
                    action: reset_action,
                    init: reset_init
                };

                const select_buttons = [
                    {
                        extend: 'selectAll',
                        className: 'hidden',
                        key: {
                            shiftKey: true,
                            key: 'x'
                        }
                    },
                    {
                        extend: 'selectNone',
                        className: 'hidden',
                        name: 'unselect_all',
                        key: {
                            shiftKey: true,
                            key: 'z'
                        }
                    }
                ];

                if (new_style) {
                    //add a clear button to the search bar on mobile
                    const searchReset = $('<a href="javascript:;" class="mobile search-reset"><i class="fa fa-times-circle"></i></a>');
                    searchReset.on('click', function () {
                        table.search('').draw();
                    });
                    $('.filter-tools label').append(searchReset);

                    if (!enable_column_chooser) {
                        return [
                            new_filter_button,
                            new_reset_button,
                            ...select_buttons
                        ];
                    }
                    return [
                        new_filter_button,
                        new_columns_button,
                        new_reset_button,
                        ...select_buttons
                    ];
                }
                else {
                    if (!enable_column_chooser) {
                        return [
                            old_filter_button,
                            old_reset_button,
                            ...select_buttons
                        ];
                    }
                    else {
                        return [
                            old_columns_button,
                            old_filter_button,
                            old_reset_button,
                            ...select_buttons
                        ];
                    }
                }
            };

            new $.fn.dataTable.Buttons(table, {
                container: 'btn-container',
                buttons: getButtons(dtwrap.settings.new_style, dtwrap.settings.enable_column_chooser)
            });

            plugin._initButtonTemplates(dtwrap, table);
        },

        _initButtonTemplates: function (dtwrap, table) {
            plugin._buildFilterButtons(table);

            if (dtwrap.settings.buttonTemplate) {
                plugin._buildCustomTableActions(dtwrap, dtwrap.settings.buttonTemplate);
            }

            if (dtwrap.settings.listControlsTemplate) {
                plugin._buildTableListControls(dtwrap, dtwrap.settings.listControlsTemplate)
            }

            if (dtwrap.settings.metricsCards) {
                plugin._buildTableMetrics(dtwrap, dtwrap.settings.metricsCards)
            }

            if ($('#js-action-table-filter').length) {
                $('<div/>', {
                    id: 'vue-lead-list-filter-badge'
                }).appendTo('#js-action-table-filter');
            }
        },

        _buildFilterButtons: function (table) {
            table.buttons(1, null).container().prependTo(
                $('.filter-tools .dataTables_filter', table.table().container())
            );
        },

        _buildCustomTableActions: function (dtwrap, templateSelector) {
            var container = $('#' + dtwrap.settings.table_id + '_wrapper').find('.action-tools');
            var template = dtwrap.renderTemplate({}, templateSelector);

            var defaultContainer = container.find('.dt-buttons').detach();
            defaultContainer.appendTo('body');

            container.append(template);
        },

        _buildTableListControls: function (dtwrap, templateSelector) {
            $('#' + dtwrap.settings.table_id + '_wrapper').find('.list-tools').append(
                dtwrap.renderTemplate({}, templateSelector)
            );
        },

        _buildTableMetrics: function (dtwrap, templateSelector) {
            $('#' + dtwrap.settings.table_id + '_wrapper').find('.metrics-cards').append(
                dtwrap.renderTemplate({}, templateSelector)
            );
        },

        _deselectAll: function (table, self, callback) {
            selected_rows = [];
            table.rows().deselect();
            $(self).removeClass('selected');

            if (typeof callback === 'function') {
                callback();
            }
        },

        selectRow: function (table, rowId) {
            var row = $('[data-row-id="' + rowId + '"]').get(0);

            table.row(row).select();
            $(row).addClass('selected');
        },

        setupAction: function (rowId, action) {
            plugin.setupForRowAction(table, rowId, function () {
                if (table.buttons(action + ':name') !== 'undefined' && table.buttons(action + ':name').length > 0) {
                    if (action === 'delete') {
                        $(table.buttons(action + ':name')[0].node).removeClass('disabled');
                    }
                    table.buttons(action + ':name').trigger();
                } else {
                    // Since GroupSMS permission controls whether send_sms button
                    // is injected in template or not, we need to trigger vue action
                    // here if send_sms is not available. Vue action does not need config
                    // object for sms form

                    $(document).trigger('dataTables:vueAction', {
                        name: action,
                        selected: plugin.getSelectedRows(),
                        config: {}
                    });
                }

                var form = $('form.js-info-panel-form');
                form.find('input[name="notifySharedAction"]').remove();
                form.append('<input name="notifySharedAction" type="hidden" value="' + action + '" />');
            });
        },

        // This is used when a single row action is triggered
        setupForRowAction: function (table, rowId, callback) {
            var self = $('.dataTable.table thead th.select-checkbox', plugin.element);

            plugin._deselectAll(table, self, function () {
                plugin.selectRow(table, rowId);

                if (typeof callback === 'function') {
                    callback();
                }
            });
        },

        _shouldShowButtons: function () {
            if (selected_rows.length > 0) {
                $('.js-multi-select-show').show();
            } else {
                $('.js-multi-select-show').hide();
            }
        },

        _selectAll: function (table, self) {
            selectAllDrawPending = true;
            $(self).removeClass('indeterminate');
            $(self).addClass('selected');

            // no callback, resetPaging is false.
            // A re-draw is trigger downstream and things get
            // screwy if you reset the paging here.
            table.ajax.reload(null, false);
            var response = table.ajax.json();
        },

        _selectAllCallback: function () {
            if (isSelectingAll) {
                var response = table.ajax.json();
                if (response.ids) {
                    selected_rows = response.ids;
                    plugin._setSelectedCallback(table);
                    plugin._shouldMarkAllSelected(plugin, table);
                    plugin._shouldShowButtons();
                }
            }
        },

        _setSelectedCallback: function (table) {
            plugin.saveRowSelection();
            plugin.updateSelectionText();
            table.button(0, 'action-tools:name').enable(selected_rows.length > 0);
            isSelectingAll = false;
            $(document).trigger('dataTables:selectAll:change', {
                selected: selected_rows
            });
        },

        _selectAllDrawCallback: function () {
            if (selectAllDrawPending) {
                table.rows('.data-row').select();
                selectAllDrawPending = false;
            }
        },

        registerEvents: function () {
            plugin._selectAllInit(plugin, table);
            plugin._filter(plugin, table);
            plugin._singleSelect(plugin, table);
            plugin._singleDeselect(plugin, table);

            table.on('buttons-action', function (e, buttonApi, dataTable, node, config) {
                if (config.onLoad) {
                    config.onLoad();
                }
            });

            table.on('draw', function () {
                // update button visibility anytime the table's row DOM changes
                plugin._shouldShowButtons();
            });

            if (plugin.settings.context_storage_key) {
                plugin.registerContextStorage(plugin.settings.context_storage_key);
            }
        },

        registerContextStorage: function (storageKey) {
            $(document).on('click contextmenu', '.dt-list-view-context', function () {
                var tr = $(this).closest('tr');
                var params = table.ajax.params();
                var pageInfo = table.page.info();
                //data url can be set in two places pending if it was changed post init()
                var dataUrl = plugin.settings.data_url;
                if (dataUrl !== table.ajax.url()) {
                    dataUrl = table.ajax.url();
                }

                var listContext = {
                    columns: params.columns,
                    filterRules: params.filterRules,
                    search: params.search,
                    order: params.order,
                    recordsTotal: pageInfo.recordsTotal,
                    currentOffset: tr.data('row-display-index'),
                    currentId: $(this).data('id'),
                    dataUrl: dataUrl,
                    page: pageInfo.page
                };

                window.localStorage.setItem(storageKey, JSON.stringify(listContext));

                const activeListKey = JSON.parse(window.localStorage.getItem('saved-lead-list-context'))?.id;

                if (activeListKey && !pipelineViewIsDirty && table.search() === '') {
                    const listedContacts = table.rows().data().map(row => row.id).toArray();
                    window.localStorage.setItem('contact-pagination', JSON.stringify(listedContacts));
                }
            });
        },

        _selectAllInit: function (dtwrap, table) {
            $('.dataTable.table thead th.select-checkbox', dtwrap.element).on('click', function () {
                isSelectingAll = true;

                if ($(this).hasClass('selected')) {
                    plugin._deselectAll(table, this, function () {
                        plugin._setSelectedCallback(table);
                        plugin._shouldShowButtons();
                        plugin._shouldMarkAllSelected(plugin, table);
                    });
                } else {
                    plugin._selectAll(table, this);
                }
            });
        },

        _filter: function (dtwrap, table) {
            $('#content').on('click', '.js-table-filter-btn', function () {
                $('.js-table-filter-btn').each(function () {
                    table.column($(this).attr('data-filter-field') + ':name').search('');
                });
                var filter_field = $(this).attr('data-filter-field');
                var filter_value = $(this).attr('data-filter-value');
                table.column(filter_field + ':name').search(filter_value != undefined ? filter_value : 1).draw();
            });
        },

        _shouldMarkAllSelected: function (dtwrap, table) {
            var recordsFiltered = table.ajax.json().recordsFiltered;
            var selectAllCheckbox = $('.dataTable.table thead th.select-checkbox', dtwrap.element);
            if (parseInt(recordsFiltered) === selected_rows.length) {
                selectAllCheckbox.removeClass('indeterminate');
                selectAllCheckbox.addClass('selected');
            } else if (selected_rows.length == 0) {
                selectAllCheckbox.removeClass('selected');
                selectAllCheckbox.removeClass('indeterminate');
            }
            else {
                selectAllCheckbox.removeClass('selected');
                selectAllCheckbox.addClass('indeterminate');
            }
        },

        _singleSelect: function (dtwrap, table) {
            table.on('select', function (e, dt, type, indexes) {
                var row_count = 0;

                table.rows(indexes).every(function () {
                    var row_id = this.data().id;
                    if (selected_rows.indexOf(row_id) === -1) {
                        selected_rows.push(row_id);
                    }
                    row_count++;
                });

                plugin._shouldShowButtons();

                plugin.updateSelectionText();
                table.button(0, 'action-tools:name').enable(selected_rows.length > 0);

                plugin._shouldMarkAllSelected(dtwrap, table);
                plugin.saveRowSelection(type);
                plugin.updateActionsMenu();

                if (!isSelectingAll) {
                    $(document).trigger('dataTables:singleSelect:change', { selected: selected_rows });
                }
            });
        },

        _singleDeselect: function (dtwrap, table) {
            table.on('deselect', function (e, dt, type, indexes) {
                table.rows(indexes).every(function () {
                    var row_id = this.data().id;
                    var index = selected_rows.indexOf(row_id);
                    if (index !== -1) {
                        selected_rows.splice(index, 1);
                    }
                });

                plugin._shouldShowButtons();
                plugin.updateSelectionText();
                plugin._shouldMarkAllSelected(dtwrap, table);
                table.button(0, 'action-tools:name').enable(selected_rows.length > 0);
                plugin.saveRowSelection(type);
                plugin.updateActionsMenu();

                if (!isSelectingAll) {
                    $(document).trigger('dataTables:singleSelect:change', { selected: selected_rows });
                }
            });
        },

        saveRowSelection: function (type) {
            $(document).trigger('dataTables:selected:change', { selectedCount: selected_rows.length });

            if (isSelectingAll || type && type === 'row') {
                sessionStorage.setItem(plugin.settings.table_id + '-selected-rows', JSON.stringify(selected_rows));
            }
        },

        updateSelectionText: function () {
            const selection_count = selected_rows.length;

            if (plugin.settings.new_style) {
                var recordsTotal = table.page.info().recordsTotal;
                $('.js-selected-count').html(selection_count.toLocaleString() + ' of ' + recordsTotal.toLocaleString() + ' selected');
            } else {
                $('.js-selected-count').html(selection_count.toLocaleString());
                $('.js-footer-info-prefix,.js-footer-info-suffix').toggle(selection_count > 0);
            }
        },

        updateActionsMenu: function () {
            var selectedRowCount = this.getSelectedRows().length;
            var minMergeCount = 0;
            var maxMergeCount = Infinity;
            var $mergeContactsAction = $('.js-merge-contacts-action');
            var minHouseholdCount = 0;
            var maxHouseholdCount = Infinity;
            var $householdContactsAction = $('.js-add-to-household-action');

            // Fetches the page of data that is available on the front end, not all of the selected data
            var availableSelectedRows = $('#' + plugin.settings.table_id).DataTable().rows('.selected').data();

            if ($mergeContactsAction.length) {
                minMergeCount = $mergeContactsAction.data().minMergeCount || 0;
                maxMergeCount = $mergeContactsAction.data().maxMergeCount || Infinity;
            }

            if (selectedRowCount >= minMergeCount && selectedRowCount <= maxMergeCount) {
                $('.dropdown-menu > li.more-than-one-selected').show();
            } else {
                $('.dropdown-menu > li.more-than-one-selected').hide();
            }

            if ($householdContactsAction.length) {
                minHouseholdCount = $householdContactsAction.data().minHouseholdCount || 0;
                maxHouseholdCount = $householdContactsAction.data().maxHouseholdCount || Infinity;
            }

            if (selectedRowCount >= minHouseholdCount && selectedRowCount <= maxHouseholdCount) {
                $('.dropdown-menu > li.more-than-one-to-household').show();
            } else {
                $('.dropdown-menu > li.more-than-one-to-household').hide();
            }

            for (var i = 0; i < availableSelectedRows.length; i++) {
                if (!availableSelectedRows[i].owned_by_or_assigned_to_current_user) {
                    $('.dropdown-menu > li.owner-or-assigned-user').hide();
                    return;
                }
            }

            $('.dropdown-menu > li.owner-or-assigned-user').show();
        },

        _includeTempColumns: function (column_list, temp_columns) {
            $.each(temp_columns, function (index, temp_column) {
                temp_column.suppress_save = true;
                var column = column_list[temp_column.column_index];
                if (typeof column.visible === 'undefined' || column.visible) {
                    temp_column.suppress_save = false;
                    return;
                }

                column.visible = true;
            });
        }
    });

})(jQuery, window, document);
